import { COMMON_RESOURCES } from "@dl/declarations";

export const CommonRouteBase = "/";
export const AuthRouteBase = "/auth";
export const AppRouteBase = "/app";

export const LandingPath = "";
export const OverviewPath = "overview";

export const SignInPath = "sign-in";
export const SignOutPath = "sign-out";
export const SetPasswordPath = "set-password";
export const TwoFAPath = "setup-2fa";

export const TagsPath = COMMON_RESOURCES.TAGS.ROUTE;
export const JobsPath = COMMON_RESOURCES.JOBS.ROUTE;
export const RolesPath = COMMON_RESOURCES.ROLES.ROUTE;
export const UsersPath = COMMON_RESOURCES.USERS.ROUTE;
export const SubtypesPath = COMMON_RESOURCES.SUBTYPES.ROUTE;
export const VerticalsPath = COMMON_RESOURCES.VERTICALS.ROUTE;
export const AssetsPath = COMMON_RESOURCES.ASSETS.ROUTE;
export const StoriesPath = COMMON_RESOURCES.STORIES.ROUTE;
export const EditorPath = "editor";
export const CollectionsPath = COMMON_RESOURCES.COLLECTIONS.ROUTE;
export const TemplatesPath = COMMON_RESOURCES.TEMPLATES.ROUTE;
export const ReportsPath = COMMON_RESOURCES.REPORTS.ROUTE;
export const EventsPath = COMMON_RESOURCES.EVENTS.ROUTE;

export const HelpPath = COMMON_RESOURCES.HELP.ROUTE;
export const ToolsPath = COMMON_RESOURCES.TOOLS.ROUTE;
export const AnalyticsPath = COMMON_RESOURCES.ANALYTICS.ROUTE;

export const ConfigurationsPath = COMMON_RESOURCES.CONFIGURATIONS.ROUTE;

export const appendRoute = (base: string, ...path: string[]): string => {
  return [base, ...path].join("/");
};

export const renderRouteOptions = (route: string): { title: string } => {
  return (
    {
      [Routes.USERS]: {
        title: "Users",
      },
      [Routes.ROLES]: {
        title: "Roles",
      },
      [Routes.JOBS]: {
        title: "Jobs",
      },
      [Routes.SUBTYPES]: {
        title: "Subtypes",
      },
      [Routes.VERTICALS]: {
        title: "Verticals",
      },
      [Routes.TAGS]: {
        title: "Related Topics",
      },
      [Routes.ASSETS]: {
        title: "Assets Manager",
      },
      [Routes.STORIES]: {
        title: "Composer / Search",
      },
      [Routes.EDITOR]: {
        title: "Composer",
      },
      [Routes.COLLECTIONS]: {
        title: "Collections",
      },
      [Routes.REPORTS]: {
        title: "Reports",
      },
      [Routes.EVENTS]: {
        title: "Events",
      },
      [Routes.TEMPLATES]: {
        title: "Templates",
      },

      [Routes.CONFIGURATIONS]: {
        title: "Configurations",
      },
      [Routes.TOOLS]: {
        title: "Tools",
      },
      [Routes.ANALYTICS]: {
        title: "Analytics",
      },
      [Routes.HELP]: {
        title: "Help",
      },
    }[route] || { title: "" }
  );
};

export const Routes = {
  LANDING: CommonRouteBase + LandingPath,
  OVERVIEW: appendRoute(AppRouteBase, OverviewPath),

  SIGN_IN: appendRoute(AuthRouteBase, SignInPath),
  SIGN_OUT: appendRoute(AuthRouteBase, SignOutPath),
  SET_PASSWORD: appendRoute(AuthRouteBase, SetPasswordPath),
  TWO_FA: appendRoute(AuthRouteBase, TwoFAPath),

  USERS: appendRoute(AppRouteBase, UsersPath),
  ROLES: appendRoute(AppRouteBase, RolesPath),
  JOBS: appendRoute(AppRouteBase, JobsPath),
  SUBTYPES: appendRoute(AppRouteBase, SubtypesPath),
  VERTICALS: appendRoute(AppRouteBase, VerticalsPath),
  ASSETS: appendRoute(AppRouteBase, AssetsPath),
  STORIES: appendRoute(AppRouteBase, StoriesPath),
  COLLECTIONS: appendRoute(AppRouteBase, CollectionsPath),
  TEMPLATES: appendRoute(AppRouteBase, TemplatesPath),
  EDITOR: appendRoute(AppRouteBase, EditorPath),
  TAGS: appendRoute(AppRouteBase, TagsPath),
  REPORTS: appendRoute(AppRouteBase, ReportsPath),
  EVENTS: appendRoute(AppRouteBase, EventsPath),

  ANALYTICS: appendRoute(AppRouteBase, AnalyticsPath),

  HELP: appendRoute(AppRouteBase, HelpPath),
  TOOLS: appendRoute(AppRouteBase, ToolsPath),

  CONFIGURATIONS: appendRoute(AppRouteBase, ConfigurationsPath),
};

export const getRouteType = (pathname: string): "auth" | "app" => {
  if (pathname.startsWith(AuthRouteBase)) {
    return "auth";
  } else if (pathname.startsWith(AppRouteBase)) {
    return "app";
  } else {
    return "app";
  }
};
